module.exports = __webpack_public_path__ + "static/media/benefits_of_our_services.c2b56cc1.png";